import React, { useContext, useEffect, Fragment } from "react";
import Slider from "react-slick";
import { observer } from "mobx-react-lite";
import WorkOrderStore from "../../../../app/stores/workorderStore";
import { INote } from "../../../../app/models/note";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import FileSaver from 'file-saver';
import '../../../../app/slider.css'
import { saveAs } from 'file-saver';

import { Image, Icon, Header, Divider, Label, ButtonContent } from "semantic-ui-react";
import { Button } from 'semantic-ui-react'
import { couldStartTrivia } from "typescript";
import axios from "axios";
import JSZip from "jszip";

import config from '../../../../app/api/apiconfig';

const baseURL = config.app.baseUrl
const thisdlphotourl = baseURL + "CP/Photo/downloadPhotos"

interface IProps {}

const settings = {
  dots: true,
  infinite: true,
  speed: 500,
  draggable: false,
  slidesToShow: 1,
  slidesToScroll: 1,
  adaptiveHeight: true,
  adaptiveWidth: true,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 3,
        infinite: true,
        dots: true
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2,
        initialSlide: 2
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
  ]
};

//  axios.defaults.baseURL = ""

async function returnSingleImage(url){
  var newUrl:String = unescape(url);
  var b = new Blob();
  

  var byteStream = await axios({
      method:"post",
      //url:"https://gilm-clientportal-test.azurewebsites.net/CP/Photo/downloadPhotos",
      url:thisdlphotourl,
      data: {
        url: newUrl
      }
  }).then((response) => {
    var arr=[]
    var bytes = atob(response.data); 
    if(bytes != "Failed to create image"){
      const byteNumbers = new Array(bytes.length);
      var count = 0;
      for (let i = 0; i < bytes.length; i++) {
        byteNumbers[i] = bytes.charCodeAt(i);
      }
      const byteArray = new Uint8Array(byteNumbers);
      const blob = new Blob([byteArray], {type: 'image/png'});
      const data = window.URL.createObjectURL(blob);
      b = blob;
    }
    
    
  })
    return b
}

async function downloadSingleImage(url){

  var newUrl:String = unescape(url);

  var byteStream = await axios({
      method:"post",
      //url:"https://gilm-clientportal-test.azurewebsites.net/CP/Photo/downloadPhotos",
      url:thisdlphotourl,
      data: {
        url: newUrl
      }
  }).then((response) => {
    var arr=[]
    var bytes = atob(response.data); 
    const byteNumbers = new Array(bytes.length);
    var count = 0;
    for (let i = 0; i < bytes.length; i++) {
      byteNumbers[i] = bytes.charCodeAt(i);
    }
    const byteArray = new Uint8Array(byteNumbers);
    const blob = new Blob([byteArray], {type: 'image/png'});
    const data = window.URL.createObjectURL(blob);


    saveAs(blob,data + ".jpg")
  })
}

function downloadMultipleImages(images,jobno){
 
    var zip = new JSZip();
    try{
      for(var i = 0; i< images.length; i ++){
        var blob = returnSingleImage(images[i].FileName)
        if (blob != null){
          zip.file("img" + i + ".jpg",blob)
        }
      }
    
      zip.generateAsync({type:"blob"}).then(function (blob) { // 1) generate the zip file
          saveAs(blob, jobno + ".zip");                          // 2) trigger the download
        });  
    }
    catch(exception){
        console.log(exception);
    }
 
}


const WorkOrderEngineerNotes: React.FC<IProps> = props => {
  const workorderStore = useContext(WorkOrderStore);
  const { selectedWorkOrderNotes: workorderNotes } = workorderStore;

  const ImgStyle = {
    width: "250px",
    height: "250px"
  };

  

  const ReturnNoteHTML = (note: INote) => {
    if (note.FileName == null) {
      return (
       
        <Image
          style={ImgStyle}
          src="/assets/no-image.png"
          floated="right"
          alt="No image for this note"
        />
        
      );
    } else {
      return (
        <Image
          
          style={ImgStyle}
          src={decodeURIComponent(note.FileName)}    
          floated="right"
          alt={note.Subject}
        />
      );
    }
  };




  const showNotes = (images: INote[]) => {
    // Get client
    let sessionObj = JSON.parse(sessionStorage.getItem("sessionObj")!);
    var cli = sessionObj.Client.Name;
    // Set client to hide information 
    var hideinfo = cli === "";
  
    if (images !== null) {
      // Sort images so that those with non-null NoteText come first
      images = images.sort((a, b) => (a.NoteText ? -1 : 1));
  
      var notes = images.map(item => (
        <Fragment >
          {ReturnNoteHTML(item)}
          <Button onClick={() => downloadSingleImage(item.FileName)}>Download Image</Button>             
          <Button onClick={() => downloadMultipleImages(images, workorderStore.selectedWorkOrder.JobNo)}>Download All Images</Button>
  
          <Divider horizontal>
            <Header as="h5">
              <Icon name="sticky note outline" />
              Engineers Note for SOR: {item.ServiceTask}
            </Header>
          </Divider>
  
          {console.log(item)}
          {item.NoteText}
  
          <div style={{ position: "absolute", bottom: 0 }}>
            <Divider horizontal />
            {hideinfo !== true && (
              <>
                <Label><Icon name="calendar alternate outline" />{dateFormatter(item.CreatedOn)}</Label>
                <Label><Icon name="user" />{item.CreatedBy}</Label>
              </>
            )}
          </div>
        </Fragment>
      ));
  
      return notes;
    }
  };
  
  
  

  useEffect(() => {
    console.log(workorderNotes.length)
    if (workorderNotes.length !== null) {
      showNotes(workorderNotes);
    }
  });

  return (
    <div
      className="ag-theme-material"
      style={{ height: "300px", width: "100%" }}
    >
      {workorderNotes.length == 0 ? "" : <Slider {...settings} className="slider-engineer-notes">{showNotes(workorderNotes)}</Slider>}
    </div>
  );
};

function dateFormatter(params:any) {
  var date = new Date(params);
  return date.toLocaleString();
}

export default observer(WorkOrderEngineerNotes);